var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTranslator = function SvgTranslator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    x: 2,
    y: 2,
    fill: "#E2FFEA",
    rx: 18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    x: 2,
    y: 2,
    stroke: "#F4FFF7",
    strokeWidth: 4,
    rx: 18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#51C394",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.222,
    clipPath: "url(#translator_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.619 20.31v-6.983A2.327 2.327 0 0 0 27.292 11H20.31a2.327 2.327 0 0 0-2.328 2.327v6.982a2.327 2.327 0 0 0 2.328 2.328h6.982a2.327 2.327 0 0 0 2.327-2.328",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.655 17.985h-2.328A2.327 2.327 0 0 0 11 20.313v6.982a2.33 2.33 0 0 0 2.327 2.327h.004l6.982-.012a2.33 2.33 0 0 0 2.324-2.327v-2.32m-5.819-2.323h-3.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.565 24.382 17.4 25.545q-.582.582-2.909 1.746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.492 22.64q.583 2.036 1.746 2.908 1.163.87 2.909 1.743m1.163-6.982 3.491-6.982 3.491 6.982m-1.163-2.327h-4.655"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "translator_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 10h20v20H10z"
  })))));
};
export default SvgTranslator;